import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentTransfer = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentTransfer' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M8,12 L4,16 L8,20 M4,16 L15,16' />
  </StyledIcon>
);
